// Clinical review intervals, one source for every page.
import { supabase } from './supabase';

const DEFAULTS = { assessment_review_days: 60, reassessment_days: 180, care_plan_review_days: 60 };
let cache = null;

export const getClinicalSettings = async () => {
  if (cache) return cache;
  const { data } = await supabase.from('clinical_settings').select('*').limit(1).maybeSingle();
  cache = { ...DEFAULTS, ...(data || {}) };
  return cache;
};
export const saveClinicalSettings = async (patch) => {
  const cur = await getClinicalSettings();
  const { error } = await supabase.from('clinical_settings').update({ ...patch, updated_at: new Date().toISOString() }).eq('agency_id', cur.agency_id);
  if (error) throw new Error(error.message);
  cache = null;
  return getClinicalSettings();
};

const addDays = (iso, n) => { const d = new Date(`${String(iso).slice(0, 10)}T12:00:00`); d.setDate(d.getDate() + n); return d; };

// Review and reassessment status for one assessment date.
export const assessmentStatus = (assessmentDate, settings) => {
  if (!assessmentDate) return { key: 'none', label: 'No assessment', tone: 'danger', reviewDue: null, reassessDue: null };
  const today = new Date(); today.setHours(12, 0, 0, 0);
  const reviewDue = addDays(assessmentDate, settings.assessment_review_days);
  const reassessDue = addDays(assessmentDate, settings.reassessment_days);
  const days = (d) => Math.round((d - today) / 86400000);
  if (days(reassessDue) < 0) return { key: 'reassess_overdue', label: 'Reassessment overdue', tone: 'danger', reviewDue, reassessDue };
  if (days(reassessDue) <= 30) return { key: 'reassess_due', label: `Reassess in ${days(reassessDue)}d`, tone: 'warn', reviewDue, reassessDue };
  if (days(reviewDue) < 0) return { key: 'review_overdue', label: 'Review overdue', tone: 'danger', reviewDue, reassessDue };
  if (days(reviewDue) <= 14) return { key: 'review_due', label: `Review in ${days(reviewDue)}d`, tone: 'warn', reviewDue, reassessDue };
  return { key: 'current', label: 'Current', tone: 'success', reviewDue, reassessDue };
};

// Fields worth showing when comparing two assessment versions.
const SKIP = new Set(['id', 'created_at', 'updated_at', 'version_number', 'version_created_at', 'version_created_by', 'ai_narrative_generated', 'ai_narrative_generated_at', 'drive_document_url', 'drive_document_name', 'client_id', 'client_uuid', 'completed_by']);
export const diffAssessments = (latest, previous) => {
  if (!latest || !previous) return [];
  const out = [];
  Object.keys(latest).forEach(k => {
    if (SKIP.has(k)) return;
    const a = JSON.stringify(previous[k] ?? null), b = JSON.stringify(latest[k] ?? null);
    if (a !== b) out.push({ field: k.replace(/_/g, ' '), before: previous[k], after: latest[k] });
  });
  return out;
};
